<script>
  import { tick } from 'svelte';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let value = 'world';
  export let style;
  export let multiline = true;
  let field;

  function cursor(pos) {
    let range = document.createRange()
    let sel = window.getSelection()
    range.setStart(field.childNodes[0], pos)
    range.collapse(true)
    sel.removeAllRanges()
    sel.addRange(range)
  }

  async function keydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (multiline) {
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        let start = range.startOffset;
        let end = range.endOffset;
        value = [value.slice(0, start), "\n", value.slice(end)].join('')

        await tick()
        cursor(start+1)
      }

    } else {
      var ret=true;
      if(e.metaKey){
        switch(e.keyCode){
          case 66: //ctrl+B or ctrl+b
          case 98: ret=false;
            break;
          case 73: //ctrl+I or ctrl+i
          case 105: ret=false;
            break;
          case 85: //ctrl+U or ctrl+u
          case 117: ret=false;
            break;
        }
      }
      if (!ret) e.preventDefault();
    }
  }
  async function paste(e) {
    e.preventDefault();

    // Get the copied text from the clipboard
    let text = e.clipboardData
      ? (e.originalEvent || e).clipboardData.getData('text/plain')
      : // For IE
      window.clipboardData
        ? window.clipboardData.getData('Text')
        : '';

    text = text.replace(/\t/g,' ')
    if (!multiline) {
      text = text.replace(/\n|\r|\t/g,' ')
    }

    let selection = window.getSelection();
    let range = selection.getRangeAt(0);
    let start = range.startOffset;
    let end = range.endOffset;

    let first = value.substr(0, start)
    let second = '';
    if (end < value.length) {
      second = value.substr(end - value.length);
    }

    value = first + text + second;
    await tick()
    cursor(start + text.length)
  }
</script>

<pre style="{style}"
      contenteditable=true bind:this={field} bind:textContent={value}
      on:keydown={keydown}
      on:paste={paste}
      on:blur={() => dispatch('blur')}
></pre>
